import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ErrorModule } from 'src/app/components/error/error.module';
import { SidenavHeaderModule } from 'src/app/components/sidenav-header/sidenav-header.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReportIssueComponent } from './report-issue.component';


@NgModule({
  declarations: [
    ReportIssueComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    PipesModule,
    MatDividerModule,
    ErrorModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    SidenavHeaderModule
  ],
  exports: [
    ReportIssueComponent
  ]
})
export class ReportIssueModule { }
